<template>
  <div>
    <div class="main-container overflow-hidden">
      <div class="cf-header-2">
        <img
          @click="goBack"
          class="mr-2 pointer"
          src="../../assets/New-imgs/interviewProcess-icons/newInt-backBtn-arrow.svg"
          alt=""
        />
        Add from Third Party
        <template v-if="['addjobs', 'search'].includes($route.query.fromPage)">
          (CV Search)
        </template>
      </div>
      <div class="thp-container mt-2">
        <div class="thp-top-container">
          <div class="d-flex align-items-center justify-content-between">
            <div class="tp-black-txt">List of Candidates</div>
            <div class="d-flex align-items-center w-40">
              <div class="exc-seacrh position-relative w-90">
                <span>
                  <img
                    class="search-pos"
                    src="../../assets/img/search-bar-icon.svg"
                    alt=""
                  />
                </span>
                <b-form-input
                  class="search-input"
                  type="search"
                  placeholder="Search Candidate"
                  v-model.trim="searchQuery"
                  debounce="500"
                  @update="filterCandidates"
                ></b-form-input>
              </div>
              <!-- <div class="ml-3">
                <img src="../../assets/talentpool/blueFilter.svg" alt="" />
              </div> -->
            </div>
            <div class="tp-bluetxt mr-4">
              Selected Candidates:&nbsp;
              {{ displayCount(candidatesSelected.length) }}
            </div>
          </div>
          <div class="mt-3 thp-main-table">
            <div class="thp-table-head">
              <div class="text-center pff-checkbox" style="width: 5%">
                <b-form-checkbox
                  v-model="selectAllCandidates"
                  @change="toggleAllCandidates"
                ></b-form-checkbox>
              </div>

              <div style="width: 15%">
                <span class="mr-2">Candidate Name</span>
                <template v-if="statusValue == 'name'">
                  <img
                    v-if="sortOrder === 'asc'"
                    class="pointer"
                    @click="
                      (statusValue = 'name'),
                        (sortOrder = 'desc'),
                        sortCandidateData()
                    "
                    src="../../assets/img/accessconnew/ascSort.svg"
                    alt=""
                  />
                  <img
                    v-if="sortOrder === 'desc'"
                    class="pointer"
                    @click="
                      (statusValue = 'name'),
                        (sortOrder = 'asc'),
                        sortCandidateData()
                    "
                    src="../../assets/img/accessconnew/descSort.svg"
                    alt=""
                  />
                </template>
                <img
                  v-else
                  @click="
                    (statusValue = 'name'),
                      (sortOrder = 'asc'),
                      sortCandidateData()
                  "
                  class="pointer"
                  src="../../assets/img/accessconnew/nosort.svg"
                  alt=""
                />
              </div>
              <div
                style="width: 15%"
                class="d-flex align-items-center justify-content-start"
              >
                Email ID
                <template v-if="statusValue == 'email'">
                  <img
                    v-if="sortOrder === 'asc'"
                    class="pointer ml-2"
                    @click="
                      (statusValue = 'email'),
                        (sortOrder = 'desc'),
                        sortCandidateData()
                    "
                    src="../../assets/img/accessconnew/ascSort.svg"
                    alt=""
                  />
                  <img
                    v-if="sortOrder === 'desc'"
                    class="pointer ml-2"
                    @click="
                      (statusValue = 'email'),
                        (sortOrder = 'asc'),
                        sortCandidateData()
                    "
                    src="../../assets/img/accessconnew/descSort.svg"
                    alt=""
                  />
                </template>
                <img
                  v-else
                  @click="
                    (statusValue = 'email'),
                      (sortOrder = 'asc'),
                      sortCandidateData()
                  "
                  class="pointer ml-2"
                  src="../../assets/img/accessconnew/nosort.svg"
                  alt=""
                />
              </div>
              <div style="width: 12%">Phone Number</div>
              <div :style="checkLocationExists ? 'width: 20%' : 'width: 26%'">
                <span>Skills</span>
              </div>
              <div
                style="width: 13%"
                v-if="checkLocationExists"
                class="d-flex align-items-center justify-content-start"
              >
                <span>Location</span>
                <template v-if="statusValue == 'location'">
                  <img
                    v-if="sortOrder === 'asc'"
                    class="pointer ml-2"
                    @click="
                      (statusValue = 'location'),
                        (sortOrder = 'desc'),
                        sortCandidateData()
                    "
                    src="../../assets/img/accessconnew/ascSort.svg"
                    alt=""
                  />
                  <img
                    v-if="sortOrder === 'desc'"
                    class="pointer ml-2"
                    @click="
                      (statusValue = 'location'),
                        (sortOrder = 'asc'),
                        sortCandidateData()
                    "
                    src="../../assets/img/accessconnew/descSort.svg"
                    alt=""
                  />
                </template>
                <img
                  v-else
                  @click="
                    (statusValue = 'location'),
                      (sortOrder = 'asc'),
                      sortCandidateData()
                  "
                  class="pointer ml-2"
                  src="../../assets/img/accessconnew/nosort.svg"
                  alt=""
                />
              </div>
              <div style="width: 10%">
                <span class="mr-2"
                  >Experience <span class="thp-bluetxt">(in years)</span></span
                >
                <template v-if="statusValue == 'experience'">
                  <img
                    v-if="sortOrder === 'asc'"
                    class="pointer"
                    @click="
                      (statusValue = 'experience'),
                        (sortOrder = 'desc'),
                        sortCandidateData()
                    "
                    src="../../assets/img/accessconnew/ascSort.svg"
                    alt=""
                  />
                  <img
                    v-if="sortOrder === 'desc'"
                    class="pointer"
                    @click="
                      (statusValue = 'experience'),
                        (sortOrder = 'asc'),
                        sortCandidateData()
                    "
                    src="../../assets/img/accessconnew/descSort.svg"
                    alt=""
                  />
                </template>
                <img
                  v-else
                  @click="
                    (statusValue = 'experience'),
                      (sortOrder = 'asc'),
                      sortCandidateData()
                  "
                  class="pointer"
                  src="../../assets/img/accessconnew/nosort.svg"
                  alt=""
                />
              </div>
              <div
                class="text-center"
                :style="checkLocationExists ? 'width: 10%' : 'width: 15%'"
              >
                <span>Actions</span>
              </div>
            </div>
            <div class="thp-table-body" id="top1">
              <template
                v-if="sendToThirdParty.length == 0 && searchQuery != ''"
              >
                <div
                  class="
                    h-100
                    d-flex
                    align-items-center
                    justify-content-center
                    flex-column
                  "
                >
                  <div>
                    <img
                      src="../../assets/newJD/newCand-empty-pic.svg"
                      alt=""
                    />
                  </div>
                  <div class="ml-4 teams-empty-container-font">
                    No matching results for "{{ searchQuery }}"
                  </div>
                </div>
              </template>
              <template v-else>
                <div
                  v-for="(candidate, index) in sendToThirdParty"
                  :key="candidate.name + index"
                  class="thp-table-row"
                >
                  <div
                    v-if="candidate.mandatoryFieldsCheck"
                    class="thp-green"
                  ></div>
                  <div v-else class="thp-red"></div>
                  <div style="width: 5%" class="text-center relativeclass">
                    <span class="pff-checkbox">
                      <b-form-checkbox
                        name="checkbox-2"
                        :value="candidate.email"
                        v-model="candidatesSelected"
                        :disabled="!candidate.mandatoryFieldsCheck"
                        @change="checkToggledCandidates"
                      >
                      </b-form-checkbox>
                    </span>
                  </div>
                  <div style="width: 15%">
                    <div class="ellipsis text-truncate pr-2">
                      <span v-b-tooltip.hover.top="candidate.name">
                        {{ candidate.name }}
                      </span>
                    </div>
                  </div>
                  <div class="text-truncate" style="width: 15%">
                    <span
                      v-b-tooltip.hover.top="candidate.email"
                      class="d-inline-block text-truncate"
                      style="min-width: auto; max-width: 100%"
                    >
                      {{ candidate.email }}
                    </span>
                  </div>
                  <div style="width: 12%">{{ candidate.phoneNumber }}</div>
                  <div
                    :style="checkLocationExists ? 'width: 20%' : 'width: 26%'"
                    class="text-truncate pr-2"
                  >
                    <span
                      class="d-inline-block text-truncate"
                      style="min-width: auto; max-width: 100%"
                      v-b-tooltip.hover.top-center="candidate.skills.join(', ')"
                    >
                      {{ candidate.skills.join(", ") }}
                    </span>
                  </div>
                  <div
                    v-if="checkLocationExists"
                    class="ellipsis pr-3"
                    style="width: 13%"
                  >
                    <span
                      class="d-inline-block text-truncate"
                      style="min-width: auto; max-width: 100%"
                      v-html="candidate.customFields.currentLocation"
                      v-b-tooltip.hover.top-center="
                        candidate.customFields.currentLocation
                      "
                    ></span>
                  </div>
                  <div style="width: 10%" class="pl-1">
                    {{ candidate.experince }}
                  </div>
                  <div
                    class="text-center pl-4"
                    :style="checkLocationExists ? 'width: 10%' : 'width: 15%'"
                  >
                    <img
                      v-b-tooltip.hover.top="'Edit'"
                      src="../../assets/talentpool/edit.svg"
                      class="mr-1 pointer"
                      alt=""
                      @click="openSidePanel(index)"
                    />
                    <template v-if="candidate.resume">
                      <b-button
                        @click="downloadResume(candidate.resume)"
                        variant="outline"
                      >
                        <img
                          class="mb-1 mr-2"
                          v-b-tooltip.hover.top="'Download Resume'"
                          src="../../assets/talentpool/download.svg"
                          alt=""
                        />
                      </b-button>
                    </template>
                    <template v-else>
                      <b-button variant="outline" class="defaultCursor">
                        <img
                          class="mb-1 mr-2"
                          src="../../assets/talentpool/disabledownload.svg"
                          alt=""
                        />
                      </b-button>
                    </template>
                    <img
                      v-b-tooltip.hover.top="'Delete'"
                      src="../../assets/New-imgs/teams-icons/teams-user-folder-delete.svg"
                      alt=""
                      class="pointer"
                      @click="openDeleteModal(candidate)"
                    />
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
        <div class="thp-footer pr-3 bluebtn">
          <b-button class="acs-cancelBtn-modal mr-3" @click="goBack"
            >Cancel</b-button
          >

          <b-button
            @click="importCandidates"
            class="acs-addBtn-modal mr-3"
            :disabled="candidatesSelected.length == 0"
            >Import</b-button
          >
        </div>
      </div>
      <transition name="cvslide">
        <div v-if="showSidePanel" class="cvsearch-trans-main-container">
          <div class="p-2">
            <div
              class="
                border-bottom
                d-flex
                align-items-center
                justify-content-between
                position-relative
                pl-3
                pt-2
                pb-3
                pr-3
              "
            >
              <div class="cs-bold-txt ml-3 mt-1 mb-1">Candidate Details</div>
              <div>
                <img src="../../assets/cvsearch/beautify.svg" alt="" />
                <template v-if="newObject.resume">
                  <b-button
                    @click="downloadResume(newObject.resume)"
                    variant="outline"
                  >
                    <img
                      v-b-tooltip.hover.top="'Download Resume'"
                      src="../../assets/talentpool/download.svg"
                      alt=""
                    />
                  </b-button>
                </template>
                <template v-else>
                  <b-button variant="outline" class="defaultCursor">
                    <img
                      class="mb-1"
                      src="../../assets/talentpool/disabledownload.svg"
                      alt=""
                    />
                  </b-button>
                </template>
                <img
                  class="rotate-on-hover pointer"
                  @click="closeSidePanel"
                  src="../../assets/img/accessconnew/blueCross.svg"
                  alt
                />
              </div>
              <img
                class="cv-pos-backarrow pointer"
                @click="closeSidePanel"
                src="../../assets/img/accessconnew/boxBackArrow.svg"
                alt
              />
            </div>
            <div class="cv-trans-body pt-1 pl-3 pr-3 pb-3">
              <b-row>
                <b-col
                  v-for="(field, index) in basicArray"
                  :key="index"
                  :cols="12"
                  class="relativeclass"
                  :class="
                    field.controlType == 'boolean'
                      ? 'd-flex align-items-center'
                      : ''
                  "
                  v-show="!field.hide"
                >
                  <div
                    v-if="
                      field.controlType == 'text' ||
                      field.controlType == 'email' ||
                      field.controlType == 'number'
                    "
                    class="topDiv mt-3"
                  >
                    <InputField
                      :type="field.controlType"
                      :label="field.label"
                      :mandatory="field.mandatory"
                      :placeholder="field.placeholder"
                      :id="field.key"
                      @select-value="updateFieldValue(field, $event)"
                      @handle-input="handleInput(field)"
                      @handle-blur="handleBlur(field)"
                      :showError="getError(field)"
                      :vmodel="getVmodel(field)"
                    />
                  </div>

                  <div
                    v-else-if="field.controlType == 'single_select'"
                    class="topDiv mt-3"
                  >
                    <SelectCustom
                      :label="field.label"
                      :mandatory="field.mandatory"
                      :placeholder="field.placeholder"
                      :id="field.key"
                      :api="field.apiEndpoint"
                      :values="field.values"
                      :dropdown="field.dropdown"
                      :fieldType="field.fieldType"
                      @select-value="updateFieldValue(field, $event)"
                      :showError="getError(field)"
                      :vmodel="getVmodel(field)"
                    />
                  </div>

                  <div
                    v-else-if="field.controlType == 'multi_select'"
                    class="topDiv mt-3"
                  >
                    <MultiSelectCustom
                      :label="field.label"
                      :mandatory="field.mandatory"
                      :placeholder="field.placeholder"
                      :id="field.key"
                      :api="field.apiEndpoint"
                      :values="field.values"
                      :dropdown="field.dropdown"
                      :fieldType="field.fieldType"
                      @select-value="updateFieldValue(field, $event)"
                      :showError="getError(field)"
                      :vmodel="getVmodel(field)"
                    />
                  </div>
                  <div
                    v-else-if="field.controlType == 'rich_text_box'"
                    class="topDiv mt-3"
                  >
                    <CustomQuillEditor
                      :type="field.controlType"
                      :label="field.label"
                      :mandatory="field.mandatory"
                      :placeholder="field.placeholder"
                      :id="field.key"
                      @select-value="updateFieldValue(field, $event)"
                      @handle-input="handleInput(field)"
                      @handle-blur="handleBlur(field)"
                      :showError="getError(field)"
                      :vmodel="getVmodel(field)"
                    />
                  </div>
                  <div
                    v-else-if="field.controlType == 'boolean'"
                    class="topDiv"
                  >
                    <SwitchBox
                      :type="field.controlType"
                      :label="field.label"
                      :mandatory="field.mandatory"
                      :placeholder="field.placeholder"
                      :id="field.key"
                      @select-value="updateFieldValue(field, $event)"
                      :vmodel="getVmodel(field)"
                    />
                  </div>

                  <div
                    v-else-if="field.controlType == 'upload_file'"
                    class="topDiv mt-3"
                  >
                    <UploadDocument
                      :type="field.controlType"
                      :label="field.label"
                      :mandatory="field.mandatory"
                      :placeholder="field.placeholder"
                      :id="field.key"
                      @select-value="updateFieldValue(field, $event)"
                      :fileFormat="field.fileFormat"
                      :showError="getError(field)"
                      :maxFileSize="field.maxFileSize"
                      :vmodel="getVmodel(field)"
                    />
                  </div>
                  <div
                    v-else-if="field.controlType == 'multi_text'"
                    class="topDiv mt-3"
                  >
                    <FormTags
                      :type="field.controlType"
                      :label="field.label"
                      :mandatory="field.mandatory"
                      :placeholder="field.placeholder"
                      :id="field.key"
                      @select-value="updateFieldValue(field, $event)"
                      :fileFormat="field.fileFormat"
                      :showError="getError(field)"
                      :maxFileSize="field.maxFileSize"
                      :vmodel="getVmodel(field)"
                    />
                  </div>
                  <div
                    v-else-if="field.controlType == 'date'"
                    class="topDiv mt-3"
                  >
                    <DateField
                      :type="field.controlType"
                      :label="field.label"
                      :mandatory="field.mandatory"
                      :placeholder="field.placeholder"
                      :id="field.key"
                      @select-value="updateFieldValue(field, $event)"
                      :showError="getError(field)"
                      :format="field.dateTimeFormat"
                      :vmodel="getVmodel(field)"
                    />
                  </div>

                  <template v-if="touchedFields[field.key]">
                    <div
                      class="newInt-required-validation-font mt-1"
                      v-if="field.mandatory && !validateField(field)"
                    >
                      {{ valText[field.key] }}
                    </div>
                    <div
                      class="newInt-required-validation-font mt-1"
                      v-else-if="field.limit > 0 && !validateField(field)"
                    >
                      {{ valText[field.key] }}
                    </div>
                  </template>
                </b-col>
              </b-row>

              <div
                class="d-flex align-items-center mt-4"
                v-if="advanceArray.length !== 0"
              >
                <div @click="roundModalSvg = !roundModalSvg" class="pointer">
                  <img
                    v-if="roundModalSvg"
                    src="../../assets/customfield/modalTopArrow.svg"
                    alt=""
                  />
                  <img
                    v-else
                    src="../../assets/customfield/modalDownArrow.svg"
                    alt=""
                  />
                </div>
                <div class="cs-bluetxt ml-2 mr-3">Advanced</div>
                <div class="modal-horizontal-line"></div>
              </div>

              <b-row v-if="roundModalSvg">
                <b-col
                  v-for="(field, index) in advanceArray"
                  :key="index"
                  :cols="12"
                  class="relativeclass"
                  :class="
                    field.controlType == 'boolean'
                      ? 'd-flex align-items-center'
                      : ''
                  "
                  v-show="!field.hide"
                >
                  <div
                    v-if="
                      field.controlType == 'text' ||
                      field.controlType == 'email' ||
                      field.controlType == 'number'
                    "
                    class="topDiv mt-3"
                  >
                    <InputField
                      :type="field.controlType"
                      :label="field.label"
                      :mandatory="field.mandatory"
                      :placeholder="field.placeholder"
                      :id="field.key"
                      @select-value="updateFieldValue(field, $event)"
                      @handle-input="handleInput(field)"
                      @handle-blur="handleBlur(field)"
                      :showError="getError(field)"
                      :vmodel="getVmodel(field)"
                    />
                  </div>

                  <div
                    v-else-if="field.controlType == 'single_select'"
                    class="topDiv mt-3"
                  >
                    <SelectCustom
                      :label="field.label"
                      :mandatory="field.mandatory"
                      :placeholder="field.placeholder"
                      :id="field.key"
                      :api="field.apiEndpoint"
                      :values="field.values"
                      :dropdown="field.dropdown"
                      :fieldType="field.fieldType"
                      @select-value="updateFieldValue(field, $event)"
                      :showError="getError(field)"
                      :vmodel="getVmodel(field)"
                    />
                  </div>

                  <div
                    v-else-if="field.controlType == 'multi_select'"
                    class="topDiv mt-3"
                  >
                    <MultiSelectCustom
                      :label="field.label"
                      :mandatory="field.mandatory"
                      :placeholder="field.placeholder"
                      :id="field.key"
                      :api="field.apiEndpoint"
                      :values="field.values"
                      :dropdown="field.dropdown"
                      :fieldType="field.fieldType"
                      @select-value="updateFieldValue(field, $event)"
                      :showError="getError(field)"
                      :vmodel="getVmodel(field)"
                    />
                  </div>
                  <div
                    v-else-if="field.controlType == 'rich_text_box'"
                    class="topDiv mt-3"
                  >
                    <CustomQuillEditor
                      :type="field.controlType"
                      :label="field.label"
                      :mandatory="field.mandatory"
                      :placeholder="field.placeholder"
                      :id="field.key"
                      @select-value="updateFieldValue(field, $event)"
                      @handle-input="handleInput(field)"
                      @handle-blur="handleBlur(field)"
                      :showError="getError(field)"
                      :vmodel="getVmodel(field)"
                    />
                  </div>
                  <div
                    v-else-if="field.controlType == 'boolean'"
                    class="topDiv mt-4"
                  >
                    <SwitchBox
                      :type="field.controlType"
                      :label="field.label"
                      :mandatory="field.mandatory"
                      :placeholder="field.placeholder"
                      :id="field.key"
                      @select-value="updateFieldValue(field, $event)"
                      :vmodel="getVmodel(field)"
                    />
                  </div>

                  <div
                    v-else-if="field.controlType == 'upload_file'"
                    class="topDiv mt-3"
                  >
                    <UploadDocument
                      :type="field.controlType"
                      :label="field.label"
                      :mandatory="field.mandatory"
                      :placeholder="field.placeholder"
                      :id="field.key"
                      @select-value="updateFieldValue(field, $event)"
                      :fileFormat="field.fileFormat"
                      :showError="getError(field)"
                      :maxFileSize="field.maxFileSize"
                      :vmodel="getVmodel(field)"
                    />
                  </div>
                  <div
                    v-else-if="field.controlType == 'multi_text'"
                    class="topDiv mt-3"
                  >
                    <FormTags
                      :type="field.controlType"
                      :label="field.label"
                      :mandatory="field.mandatory"
                      :placeholder="field.placeholder"
                      :id="field.key"
                      @select-value="updateFieldValue(field, $event)"
                      :fileFormat="field.fileFormat"
                      :showError="getError(field)"
                      :maxFileSize="field.maxFileSize"
                      :vmodel="getVmodel(field)"
                    />
                  </div>
                  <div
                    v-else-if="field.controlType == 'date'"
                    class="topDiv mt-3"
                  >
                    <DateField
                      :type="field.controlType"
                      :label="field.label"
                      :mandatory="field.mandatory"
                      :placeholder="field.placeholder"
                      :id="field.key"
                      @select-value="updateFieldValue(field, $event)"
                      :showError="getError(field)"
                      :format="field.dateTimeFormat"
                      :vmodel="getVmodel(field)"
                    />
                  </div>

                  <template v-if="touchedFields[field.key]">
                    <div
                      class="newInt-required-validation-font mt-1"
                      v-if="field.mandatory && !validateField(field)"
                    >
                      {{ valText[field.key] }}
                    </div>
                    <div
                      class="newInt-required-validation-font mt-1"
                      v-else-if="field.limit > 0 && !validateField(field)"
                    >
                      {{ valText[field.key] }}
                    </div>
                  </template>
                </b-col>
              </b-row>
            </div>
            <div
              class="
                d-flex
                align-items-center
                justify-content-end
                border-top
                pr-4
                bluebtn
                pt-2
                mt-2
              "
            >
              <b-button class="acs-cancelBtn-modal mr-4" @click="closeSidePanel"
                >Cancel</b-button
              >
              <b-button class="acs-addBtn-modal" @click="updateCandidateData"
                >Update</b-button
              >
            </div>
          </div>
        </div>
      </transition>
    </div>
    <AddToJDSuceessMultiple
      v-if="showCandTPModal"
      :showCandTPModal="showCandTPModal"
      :from="'addtotalentpool'"
      :selectedjd="getJobIDs"
      :posType="posType"
      :candPosData="candPosData"
      :candidateSelectedToThirdParty="populatedCustomFields"
      @close-modals="checkAndClose"
      @hide-cand-tp-modal="(showCandTPModal = false), goBack()"
    />
    <DeleteModal
      v-if="showDeleteModal"
      :showModal="showDeleteModal"
      @close-modal="showDeleteModal = false"
      :deleteData="deleteData"
      @delete-event="deleteCandidate"
      @closeDeleteJd="showDeleteModal = false"
    />
    <AssignSinglePositionID
      v-if="showSingleAssign"
      :showSingleAssign="showSingleAssign"
      :positionIDs="positionIDs"
      :candidate="items[0]"
      :failure="failure"
      @change-failure="failure = false"
      @add-to-job="addSingleCand"
      @close-modal="closeSingleAssign"
    />

    <AddCandidatesToJob
      v-if="showAddCands"
      :showAddCands="showAddCands"
      :failure="failure"
      @change-failure="failure = false"
      @go-to-position="gotoPosition"
      @close-modal="closeAddCandidates"
    />

    <AssignPositionID
      v-if="showAssignPositionIDs"
      :showAssignPositionIDs="showAssignPositionIDs"
      :items="items"
      :failure="failure"
      :positionIDOptions="positionIDOptions"
      @change-failure="failure = false"
      @set-position="setPosition"
      @add-cand-to-job="addSingleCand"
      @close-modal="closeAssignPositionIDs"
    />
  </div>
</template>

<script>
import {
  addCacheCandidates,
  getCacheCandidates,
  deleteCacheCandidates,
  getCustomerFields,
  uploadCacheCandidatesFiles,
  addCandidatestoDB,
  downloadAnyFile,
  getMyPositionID,
} from "../../utils/apiFunctions.js";
import {
  dynamicRules,
  validateField,
  showError,
} from "../../utils/customFields";
import { downloadResumeFile } from "../../utils/download.js";
import InputField from "../../components/InputComponents/Input.vue";
import SwitchBox from "../../components/InputComponents/Switch.vue";
import CustomQuillEditor from "../../components/InputComponents/CustomQuillEditor.vue";
import SelectCustom from "../../components/InputComponents/SelectCustom.vue";
import MultiSelectCustom from "../../components/InputComponents/MultiSelectCustom.vue";
import UploadDocument from "../../components/InputComponents/UploadDocument.vue";
import FormTags from "../../components/InputComponents/FormTags.vue";
import DateField from "../../components/InputComponents/DateField.vue";
import DeleteModal from "../../components/modals/DeleteModal.vue";
import AddToJDSuceessMultiple from "../../controllers/Talentpool/AddToJDSuceessMultiple.vue";
import toast from "../../components/mixin/toast";
import AssignSinglePositionID from "../../components/Kanban/modal/AssignSinglePositionID.vue";
import AddCandidatesToJob from "../../components/Kanban/modal/AddCandidatesToJob.vue";
import AssignPositionID from "../../components/Kanban/modal/AssignPositionID.vue";
import { mapGetters } from "vuex";

export default {
  name: "AddFromThirdParty",
  data() {
    return {
      // STRINGS
      searchQuery: "",
      sortOrder: "",
      statusValue: "",

      // BOOLEAN
      showSidePanel: false,
      roundModalSvg: false,
      showDeleteModal: false,
      showLoader: false,
      selectAllCandidates: false,
      showCandTPModal: false,
      showSingleAssign: false,
      showAddCands: false,
      showAssignPositionIDs: false,
      failure: false,

      // OBJECTS
      validations: {
        customFields: {},
      },
      valText: {
        customFields: {},
      },
      newObject: {},
      touchedFields: {},
      deleteData: {
        title: "Delete Candidate",
        message1: "Are you sure you want to delete",
        message2: " candidate ? This action cannot be undone.",
        data: "",
      },
      particularCandidateDetails: { success: [], failed: [] },
      populatedCustomFields: { candidates: [] },

      // ARRAYS
      addjddata: [],
      customFieldsArray: [],
      basicArray: [],
      advanceArray: [],
      candidatesSelected: [],
      sendToThirdParty: [],
      items: [],
      positionIDOptions: [],
      positionIDs: [],
      candPosData: {},
      posType: null,
    };
  },
  mixins: [toast],
  components: {
    InputField,
    SwitchBox,
    CustomQuillEditor,
    SelectCustom,
    MultiSelectCustom,
    UploadDocument,
    FormTags,
    DateField,
    DeleteModal,
    AddToJDSuceessMultiple,
    AssignSinglePositionID,
    AddCandidatesToJob,
    AssignPositionID,
  },
  async created() {
    await this.getCustomFields();
    await this.getCacheCandidateData();
    if (this.$route.query.fromPage == "addjobs") await this.getMyPositionIDs();
  },
  watch: {
    candidatesSelected: {
      handler() {
        // Update selectAllCandidates based on candidatesSelected
        const nonDisabledCandidates = this.candidates.filter(
          (candidate) => candidate.mandatoryFieldsCheck
        );
        this.selectAllCandidates =
          nonDisabledCandidates.length > 0 &&
          nonDisabledCandidates.every((candidate) =>
            this.candidatesSelected.includes(candidate.email)
          );
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters("cvSearchVUEX", {
      getJobIDs: "getJobIDs",
    }),
    ...mapGetters("jobDescriptionVUEX", {
      customerDetail: "getCustomerDetail",
    }),
    mandatoryFields() {
      return this.customFieldsArray
        .filter((field) => field.mandatory)
        .map((field) => field.key);
    },
    checkLocationExists() {
      return this.customFieldsArray.some(
        (field) => field.key === "currentLocation"
      );
    },
  },
  methods: {
    setPosition(data) {
      this.items.map((obj) => {
        if (obj.email == data.item.email) {
          obj.positionID = data.value;
        }
      });
      this.$forceUpdate();
    },
    checkAndClose() {
      this.closeAddCandidates();
      this.closeSingleAssign();
      this.closeAssignPositionIDs();
    },
    closeAssignPositionIDs() {
      this.showAssignPositionIDs = false;
      this.posType = null;
    },
    closeSingleAssign() {
      this.showSingleAssign = false;
      this.posType = null;
      this.candPosData = {};
    },
    addSingleCand(cand) {
      this.items = cand;
      this.posType = "manual";
      this.items.map((obj) => {
        this.candPosData[obj.email] = obj.positionID;
      });
      this.showCandTPModal = true;
      // this.addCandidate("manual");
      // this.addCandsToJob();
    },
    closeAddCandidates() {
      this.showAddCands = false;
      this.posType = null;
    },
    showAssignModal(cand) {
      this.items.push(cand);
      this.showSingleAssign = true;
    },
    showAddCand() {
      let candidates = [];
      this.populatedCustomFields.candidates.map((obj) => {
        let values = {};
        values.email = obj;
        let candName = this.sendToThirdParty.filter((val) => {
          if (val.email == obj) {
            return val.name;
          }
        });
        values.name = candName[0].name;
        candidates.push(values);
      });
      this.items = candidates;
      this.showAddCands = true;
    },
    // Close the candidate details Panel
    closeSidePanel() {
      this.showSidePanel = false;
      this.getCacheCandidateData();
    },
    async getMyPositionIDs() {
      try {
        let payload = {
          type: 1,
          jobID: this.getJobIDs[0],
          lead: this.customerDetail.lead,
        };
        const res = await getMyPositionID(payload);
        if (res.status == 200) {
          this.positionIDs = res.data.data.data;
        }
      } catch (error) {
        console.error(error);
      }
    },
    gotoPosition(value) {
      if (value == 2) {
        if (this.items.length > 1) {
          this.items.forEach((obj) => (obj.positionID = this.positionIDs[0]));
          this.positionIDOptions = this.positionIDs;
          this.showAssignPositionIDs = true;
        } else {
          this.showSingleAssign = true;
        }
      } else {
        this.posType = "automatic";
        this.showCandTPModal = true;
        // this.addCandidate("automatic");
        // this.addCandsToJob('automatic');
      }
    },
    // Toggle all candidates based on selectAllCandidates state
    toggleAllCandidates() {
      if (this.selectAllCandidates) {
        // Select all candidates that are not disabled
        this.candidatesSelected = this.sendToThirdParty
          .filter((candidate) => candidate.mandatoryFieldsCheck)
          .map((candidate) => candidate.email);
      } else {
        // Deselect all candidates
        this.candidatesSelected = [];
      }
    },
    checkToggledCandidates() {
      // Check if all candidates are selected
      const allCandidatesSelected = this.sendToThirdParty
        .filter((candidate) => candidate.mandatoryFieldsCheck)
        .every((candidate) =>
          this.candidatesSelected.includes(candidate.email)
        );

      // Update selectAllCandidates based on the above condition
      this.selectAllCandidates = allCandidatesSelected;
    },
    // Download Resume
    async downloadResume(resume) {
      const res = await downloadAnyFile(resume);
      if (res.status == 200) {
        const link = res.data.data.downloadLink;
        // implemented bcz once we click on download resume that page shouldn't go blank
        const candidateName = res.data.data.name;

        await downloadResumeFile(link, candidateName);
      }
    },
    // Success Failure Modal Functions
    displayCount(data) {
      if (data < 9) {
        return "0" + data;
      } else {
        return data;
      }
    },
    addtojddetails(data) {
      this.particularCandidateDetails = data;
    },
    // Routing
    goBack() {
      this.$router.go(-1);
    },
    // Filter and Sort Methods
    async filterCandidates() {
      await this.getCacheCandidateData();
      const searchLowerCase = this.searchQuery.toLowerCase();
      this.sendToThirdParty = this.sendToThirdParty.filter((candidate) => {
        // Check if the candidate's name, email, phoneNumber, or any skill matches the searchQuery
        const nameMatch = candidate.name
          .toLowerCase()
          .includes(searchLowerCase);
        const emailMatch = candidate.email
          .toLowerCase()
          .includes(searchLowerCase);
        const phoneMatch = candidate.phoneNumber
          .toLowerCase()
          .includes(searchLowerCase);

        // Check if any skill in the candidate's skills array matches the searchQuery
        const skillMatch = candidate.skills.some((skill) =>
          skill.toLowerCase().includes(searchLowerCase)
        );

        return nameMatch || emailMatch || phoneMatch || skillMatch;
      });
    },
    sortCandidateData() {
      let sortBy;
      switch (this.statusValue) {
        case "name":
          sortBy = (a, b) =>
            this.sortOrder === "asc"
              ? a.name.localeCompare(b.name)
              : b.name.localeCompare(a.name);
          break;
        case "email":
          sortBy = (a, b) =>
            this.sortOrder === "asc"
              ? a.email.localeCompare(b.email)
              : b.email.localeCompare(a.email);
          break;
        case "location":
          sortBy = (a, b) =>
            this.sortOrder === "asc"
              ? a.customFields.currentLocation.localeCompare(
                  b.customFields.currentLocation
                )
              : b.customFields.currentLocation.localeCompare(
                  a.customFields.currentLocation
                );
          break;
        case "experience":
          sortBy = (a, b) => {
            const experienceA = parseFloat(a.experince);
            const experienceB = parseFloat(b.experince);
            if (this.sortOrder === "asc") {
              return experienceA - experienceB;
            } else {
              return experienceB - experienceA;
            }
          };
          break;
        default:
          sortBy = () => 0; // No sorting
      }
      this.sendToThirdParty.sort(sortBy);
    },
    // Candidate Data related apis
    async getCacheCandidateData() {
      try {
        const res = await getCacheCandidates();
        if (res.status == 200) {
          this.sendToThirdParty = res.data.data;
          this.sendToThirdParty.forEach((candidate) => {
            candidate.mandatoryFieldsCheck =
              this.checkMandatoryFields(candidate);
          });
        }
      } catch (error) {
        console.error("err:", error);
      }
    },
    async getCustomFields() {
      try {
        let parentID = "5";
        let response = await getCustomerFields({ parentID });
        if (response.status == 200) {
          this.customFieldsArray = response.data.data.fields;
          // Iterate through the original array and push objects into respective arrays based on category value
          this.customFieldsArray.forEach((obj) => {
            if (obj.category === 1 || obj.category == null) {
              this.basicArray.push(obj);
            } else if (obj.category === 2) {
              this.advanceArray.push(obj);
            }
          });

          const object = {
            customFields: {},
          };
          this.touchedFields = {};
          this.customFieldsArray.forEach((field) => {
            if (field.fieldType == "default") {
              field.controlType == "multi_select" ||
              field.controlType === "multi_text"
                ? (object[field.key] = [])
                : (object[field.key] = "");
              this.touchedFields[field.key] = false;
            } else {
              field.controlType == "multi_select" ||
              field.controlType === "multi_text"
                ? (object["customFields"][field.key] = [])
                : (object["customFields"][field.key] = "");
              this.touchedFields[field.key] = false;
            }
          });
        }
      } catch (error) {
        console.error(error);
      }
    },
    async deleteCandidate() {
      try {
        let payload = {};
        payload.emails = [this.newObject.email];
        let res = await deleteCacheCandidates(payload);
        if (res.status == 200) {
          this.showDeleteModal = false;
          this.getCacheCandidateData();
        }
      } catch (error) {
        console.error(error);
      }
    },
    async importCandidates() {
      switch (this.$route.query.fromPage) {
        case "search":
          try {
            const payload = {
              emails: this.candidatesSelected,
            };
            const res = await addCandidatestoDB(payload);
            if (res.status == 200) {
              this.successModal("Candidates added to Talent Pool successfully");
              this.goBack();
            } else {
              let text =
                this.candidatesSelected.length > 1 ? "Candidates" : "Candidate";
              this.errorModal(`${text} already exists in Talent Pool`);
            }
          } catch (error) {
            console.error(error);
            let text =
              this.candidatesSelected.length > 1 ? "Candidates" : "Candidate";
            this.errorModal(`${text} already exists in Talent Pool`);
          }
          break;
        case "addjobs":
          this.populatedCustomFields = { candidates: this.candidatesSelected };
          // if (this.$route.query.jobID)
          if (this.positionIDs.length > 1) this.showAddCand();
          else this.showCandTPModal = true;
          break;
      }
    },
    async updateCandidateData() {
      this.validations = dynamicRules(this.customFieldsArray);
      const invalidForm = this.validateForm();
      if (!invalidForm) {
        try {
          await this.uploadCandidateDocuments();
          let payload = { candidates: [this.newObject] };
          const res = await addCacheCandidates(payload);
          if (res.status == 200) {
            this.successModal("Candidate details updated successfully");
          }
        } catch (error) {
          console.error(error);
          this.errorModal("Candidate details are not updated");
        } finally {
          this.roundModalSvg = false;
          this.showSidePanel = false;
          this.getCacheCandidateData();
        }
      } else {
        this.errorModal("Fill all the necessary details");
      }
    },
    async uploadCandidateDocuments() {
      const formData = new FormData();
      formData.append("email", this.newObject.email);
      const attachments = [];

      for (const key in this.newObject.customFields) {
        const value = this.newObject.customFields[key];
        if (value instanceof File) {
          formData.append(key, value);
          attachments.push({ attachmentName: key });
        }
      }
      for (const key in this.newObject) {
        const value = this.newObject[key];
        if (value instanceof File) {
          formData.append(key, value);
          attachments.push({ attachmentName: key });
        }
      }
      formData.append("attachment", JSON.stringify(attachments));

      if (attachments.length !== 0) {
        try {
          let res = await uploadCacheCandidatesFiles(formData);
          if (res.status == 200) {
            res = res.data.data;
            // Update the properties directly on the newObject
            Object.keys(this.newObject).forEach((key) => {
              if (Object.prototype.hasOwnProperty.call(res, key)) {
                this.newObject[key] = res[key];
              }
            });

            // Update the properties within customFields if it exists
            Object.keys(this.newObject.customFields).forEach((key) => {
              if (Object.prototype.hasOwnProperty.call(res, key)) {
                this.newObject.customFields[key] = res[key];
              }
            });
          }
        } catch (error) {
          console.error(error);
        }
      }
    },
    // For green and red lines in table
    checkMandatoryFields(candidate) {
      this.validations = dynamicRules(this.customFieldsArray);
      for (const field of this.customFieldsArray) {
        const value =
          field.fieldType === "default"
            ? candidate[field.key]
            : candidate.customFields[field.key];
        const rules =
          field.fieldType === "default"
            ? this.validations[field.key]
            : this.validations.customFields[field.key];

        // Check if the field is required
        if (rules && rules.required) {
          if (field.controlType === "multi_select") {
            if (!Array.isArray(value) || (value && value.length === 0)) {
              return false;
            }
          } else if (field.controlType === "email") {
            const emailRegex =
              /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i;
            if (!value) {
              return false;
            }
            if (!emailRegex.test(value)) {
              return false;
            }
            if (field.limit && value.length > field.limit) {
              return false;
            }
          } else if (field.controlType === "single_select") {
            if (Array.isArray(field.values) && field.values.length > 0) {
              const hasDefault = field.values.some((opt) => opt.isDefault);
              if (!hasDefault && !value) {
                return false;
              }
            } else if (!value) {
              return false;
            }
          } else if (field.controlType === "upload_file" && value) {
            const fileName = value.split("/").pop();
            const fileExtension = fileName.split(".").pop().toLowerCase();
            const allowedExtensions = field.fileFormat.map((ext) =>
              ext.toLowerCase()
            );
            if (!allowedExtensions.includes(fileExtension)) {
              return false;
            }
          } else if (field.controlType === "multi_text") {
            if (!value || value.length == 0) {
              return false;
            }
          } else if (field.controlType === "rich_text_box") {
            if (!value) {
              return false;
            } else {
              let plainText = value.replace(/<[^>]+>/g, ""); // Remove HTML tags
              plainText = plainText.replace(/&nbsp;/g, " "); // Replace &nbsp; with regular spaces
              plainText = plainText.trim(); // Trim leading and trailing whitespace
              if (!plainText.length) {
                return false;
              } else if (field.limit && plainText.length > field.limit) {
                return false;
              }
            }
          } else {
            // Check if the value is empty or exceeds the character limit
            if (!value) {
              return false;
            } else if (field.limit && value.length > field.limit) {
              return false;
            } else if (
              (field.key === "phoneNumber" || field.key === "altPhoneNumber") &&
              field.limit &&
              value.length < field.limit
            ) {
              return false;
            } else if (field.key === "openingsCount" && value == 0) {
              return false;
            }
          }
        } else {
          if (field.controlType === "email" && value) {
            const emailRegex =
              /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i;
            if (!emailRegex.test(value)) {
              return false;
            }
            if (field.limit && value.length > field.limit) {
              return false;
            }
          } else if (field.controlType === "upload_file" && value) {
            const fileName = value.split("/").pop();
            const fileExtension = fileName.split(".").pop().toLowerCase();
            const allowedExtensions = field.fileFormat.map((ext) =>
              ext.toLowerCase()
            );

            if (!allowedExtensions.includes(fileExtension)) {
              return false;
            }
          }
        }
      }
      return true;
    },
    // To delete Candidate
    openDeleteModal(candidate) {
      this.newObject = {};
      this.deleteData.data = candidate.name;
      this.newObject = candidate;
      this.showDeleteModal = true;
    },
    // To edit candidate
    openSidePanel(index) {
      this.newObject = {};
      this.roundModalSvg = false;
      this.showSidePanel = true;
      this.newObject = this.sendToThirdParty[index];

      this.populateBasicAdvanceArrays();
      this.validations = dynamicRules(this.customFieldsArray);
      this.validateForm();
    },
    // To populate basic and advance array to render the custom fields form
    populateBasicAdvanceArrays() {
      var found = false;
      for (var i = 0; i < this.basicArray.length; i++) {
        if (
          this.basicArray[i].key == "source" &&
          this.newObject[this.basicArray[i].key] === "other"
        ) {
          var seqId = this.basicArray[i].seq;
          for (var j = 0; j < this.basicArray.length; j++) {
            if (
              this.basicArray[j].seq === seqId &&
              this.basicArray[j].hide === true
            ) {
              this.basicArray[j].hide = false;
              found = true;
              break; // No need to continue once updated
            }
          }
          if (found) {
            break; // No need to continue searching once updated
          }
        }
      }
      for (var k = 0; k < this.advanceArray.length; k++) {
        if (
          this.advanceArray[k].key == "noticePeriod" &&
          this.newObject[this.advanceArray[k].key] === "other"
        ) {
          var advanceSeqId = this.advanceArray[k].seq;
          for (var l = 0; l < this.advanceArray.length; l++) {
            if (
              this.advanceArray[l].seq === advanceSeqId &&
              this.advanceArray[l].hide === true
            ) {
              this.advanceArray[l].hide = false;
              found = true;
              break; // No need to continue once updated
            }
          }
          if (found) {
            break; // No need to continue searching once updated
          }
        }
      }
    },
    // Custom Form Related Functions
    validateForm() {
      let invalidForm = false;
      for (let i = 0; i < this.customFieldsArray.length; i++) {
        const field = this.customFieldsArray[i];
        this.touchedFields[field.key] = true;
        if (!validateField(field, this)) {
          invalidForm = true;
        }
      }
      return invalidForm;
    },
    updateFieldValue(field, value) {
      if (field.fieldType === "default") {
        this.$set(this.newObject, field.key, value);
      } else {
        this.$set(this.newObject.customFields, field.key, value);
      }
      if (
        (field.key === "source" || field.key === "noticePeriod") &&
        value === "other"
      ) {
        if (field.category === 1 || field.category == null) {
          const selectedIndex = this.basicArray.findIndex(
            (option) => option.seq === field.seq && option.hide
          );
          this.basicArray[selectedIndex].hide = false;
        } else {
          const selectedIndex = this.advanceArray.findIndex(
            (option) => option.seq === field.seq && option.hide
          );
          this.advanceArray[selectedIndex].hide = false;
        }
      }
      this.$forceUpdate();
      validateField(field, this);
    },
    validateField(field) {
      return validateField(field, this);
    },
    handleInput(field) {
      this.touchedFields[field.key] = true;
      this.$forceUpdate();
    },
    handleBlur(field) {
      if (this.touchedFields[field.key] && !this.validations[field.key]) {
        validateField(field, this);
        this.$forceUpdate();
      }
    },
    getVmodel(field) {
      return field.fieldType == "default"
        ? this.newObject[field.key]
        : this.newObject.customFields[field.key];
    },
    getError(field) {
      return showError(field, this.touchedFields[field.key], this);
    },
  },
};
</script>

<style></style>
